<div id="topbar">
  <div id="over">
    <div class="loadbar"></div>
  </div>
  <div id="under">
    <div class="left-group">
      <div id="menu" class="dropdown">
        <app-dropdown-menu [burger]="true"></app-dropdown-menu>
      </div>
      <div *ngIf="projectLoaded" class="title-container">
        <p class="project-title" matTooltip="{{ getProjectTitle() }}">
          {{ getProjectTitle(true) }}
        </p>
      </div>
    </div>
    <div id="logo">
      <img class="logo"
        alt="anessa ada logo"
        (click)="openPlatformPicker()"
        src="/dbapi/logo?product=ADA&accountid={{getAccountID()}}"
      />
    </div>
    <div class="right-side">
      <div id="powered-by-logo" *ngIf="isCustomLogo">
        <img class="powered-by-logo" src="assets/powered-by-anessa.svg" alt="powered by anessa logo"/>
      </div>
      <div *ngIf="projectLoaded" class="padding-right">
        <app-alerts-menu></app-alerts-menu>
      </div>
      <div class="help-symbol padding-right">
        <a href="mailto:support@anessa.com" id="help">
          <mat-icon>help</mat-icon>
        </a>
      </div>
      <div>
        <app-language-menu></app-language-menu>
      </div>
      <div id="namebox">
        <app-dropdown-menu [burger]="false"></app-dropdown-menu>
      </div>
    </div>
  </div>
</div>
